import { SEO } from "gatsby-theme-core";
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@streamo/helper/methods";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import { PageHeader01, PricingPlanArea01 } from "gatsby-theme-container";

const PricingPlanPage = ({ data }) => {
    const content = normalizedData(data?.page?.content || []);
    return (
        <Layout>
            <SEO pageName="Pricing Plan" />
            <HeaderOne data={{ ...data?.header, ...data.navigation }} />
            <PageHeader01 data={content?.["page-header-section"]} />
            <PricingPlanArea01 data={content?.["pricing-plan-section"]} />
            <FooterOne data={{ ...data?.footer, ...data?.contact }} />
        </Layout>
    );
};

export const query = graphql`
    query PricingPlanTwoPageQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "pricing-plan" }) {
            content {
                ...PageContent
            }
        }
    }
`;
PricingPlanPage.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default PricingPlanPage;
